module.exports = __webpack_public_path__ + "img/Explore2.70f0a84a.jpg";